import axios from "axios";
import { baseUrl } from "../utils/constants";

// Get All Tickets API //
export const getTicketsStats = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/get-tickets-stats`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                }
            });
            
            resolve(response.data.data)
        } catch (error) {
            console.log("api error::", error.response);
            reject(error.response)
        }
    })
}

// Get Images URL //
export const getImageUrlApi = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/common/get-image-urls`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}